import { useSuspenseQuery } from "@apollo/client/react";

import {
  GetRelationTypesModelContextDocument,
  type GetRelationTypesModelContextQuery,
  type GetRelationTypesModelContextQueryVariables,
} from "~/features/admin/relationTypes/gqls";
import type { CategoryOption } from "~/features/admin/relationTypes/types";
import { useTenant } from "~/features/tenant/context";

/**
 * Returns the tenant's categories, used as source / target options in the
 * create and edit forms. The forms lazy-suspend on first open (V1 loaded the
 * same list at the page level via a context provider).
 */
export function useRelationTypesModelContext(): { categories: CategoryOption[] } {
  const { tenantId } = useTenant();
  if (!tenantId) {
    throw new Error("Tenant ID is required");
  }

  const { data } = useSuspenseQuery<GetRelationTypesModelContextQuery, GetRelationTypesModelContextQueryVariables>(
    GetRelationTypesModelContextDocument,
    { variables: { tenantId } },
  );

  return { categories: data?.categories ?? [] };
}
